<template>
  <div class="offer-main">
    <div class="img-box">
      <div class="text-c">
        <img class="yuanbao posa" src="../assets/img/yuanbao_homepage.png" alt="">
        <img class="title" src="http://wwj.jijiagames.com//web/act/20190410/Title_1.png" alt="">
        <img class="test-offer" src="../assets/img/Title_3.png" alt="">
        <img class="offer-num" src="../assets/img/Title_4.png" alt="">
        <img class="hr posa" src="../assets/img/HR_homepage.png" alt="">
        <img class="engineer posa" src="../assets/img/engineer_homepage.png" alt="">
        <img class="minister posa" src="../assets/img/prime minister_homepage.png" alt="">
        <img class="sales posa" src="../assets/img/sales_homepage.png" alt="">
        <p class="num-txt">{{num}}</p>
      </div>
      <div class="btn-box">
        <img class="pencil" src="../assets/img/brush_homepage.png" alt="">
        <img @click="enterInterview" class="go-btn" src="../assets/img/Title_2.png" alt="">
      </div>
         <audio  preload="auto" loop="loop" ref="chooseMusic">
          <source src="../assets/audio/choose.mp3">
        </audio>
        <p class="host-text text-c">本次大会由韵文博鉴、文物加联合举办</p>
        <img class="host-img" src="../assets/img/LOGO_homepage.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
    props: ['chooseMusicFlag'],
    data() {
        return {
            num: 0
        };
    },
    mounted() {
        this.offerNum();
    },
    methods: {
        offerNum() {
            const oldTime = new Date('2019/4/24').getTime();
            const currentTime = new Date().getTime();
            this.num = ((currentTime - oldTime) / 1000 / 60).toFixed(0) - 570;
            setInterval(() => {
                this.num++;
            }, 60000);
        },
        enterInterview() {
            if (this.chooseMusicFlag) {
                this.$refs.chooseMusic.play();
            }
            else {
                this.$refs.chooseMusic.pause();
            }
            setTimeout(() => {
                this.$emit('next', 3);
            });
        }
    }
};
</script>

<style lang="stylus" scoped>
.offer-main
  width 100%
  height 100%
  background url("../assets/img/bg_homepage.jpg") 0 0/100% 100% no-repeat
.img-box
    box-sizing border-box
    width 100%
    height 100%
    position relative
    padding-top:2.4rem
    .num-txt
        width 1.42rem
        position absolute
        top 6.23rem
        left 2.35rem
        font-size 0.24rem
        overflow: hidden
        text-overflow:ellipsis
        white-space:nowrap
    .title
        margin-bottom 1rem
    .posa
        position absolute
    .hr
        top 4.53rem
        left 0
        animation down 1.2s ease-out infinite
    .yuanbao
        top 1.62rem
        left 0.15rem
    .engineer
        top 4.74rem
        right 0
        animation down 1.2s ease-out infinite
    .minister
        bottom 0
        right 0
        animation down 1.2s ease-out infinite
    .sales
        left 0
        bottom 0
        animation down 1.2s ease-out infinite
    .test-offer
        margin-bottom 0.2rem
    .offer-num
        margin-bottom 1.08rem
    .btn-box
      position relative
      margin 0 auto
      text-align center
      width 3.55rem
      height 0.83rem
      -webkit-backface-visibility: hidden
      animation: shandong 1.2s ease-out infinite
      .pencil
        position absolute
        top -0.73rem
        right 0.15rem
    .text-c
      text-align center
    .host-text
      width 100%
      position absolute
      bottom 1.26rem
      left 0
      font-size 0.24rem
      color:#686868
    .host-img
      position absolute
      bottom 0.32rem
      left: 50%;
      transform: translateX(-50%);
@keyframes down
    0%{
        transform translateY(0)
    }
    30%{
        transform translateY(-5px)
    }
    50%{
        transform translateY(-6px)
    }
    10%{
        transform translateY(0px)
    }
@keyframes shandong {
  50% {
    transform: scale(1.25)
  }

  100% {
    transform: scale(1)
  }
}
</style>
